import {
    PDF_HEIGHT,
    PDF_WIDTH,
    PRINT_OPTION_AVAILABILITY,
    PRINT_OPTION_HOLDS,
    PRINT_OPTION_SEAT_LABELS,
    PRINT_OPTION_TIER_COLOR,
} from '../../constants/pdf-constants';
import {
    DEFAULT_RENDER_OPTIONS,
    RENDER_OPTION_AVAILABILITY,
    RENDER_OPTION_HOLDS,
    RENDER_OPTION_SEAT_LABELS,
    RENDER_OPTION_TIERS_COLORS,
} from '../../constants/render-constants';
import genericMapRendererFactory from '../../helpers/generic-map-renderer';
import instancePDFRenderer from '../../helpers/pdf-renderer';

const PDF_TO_RENDER_OPTIONS_MAP = {
    [RENDER_OPTION_HOLDS]: PRINT_OPTION_HOLDS,
    [RENDER_OPTION_SEAT_LABELS]: PRINT_OPTION_SEAT_LABELS,
    [RENDER_OPTION_TIERS_COLORS]: PRINT_OPTION_TIER_COLOR,
    [RENDER_OPTION_AVAILABILITY]: PRINT_OPTION_AVAILABILITY,
};

const pdfManagerFactory = ({ model }) => {
    const pdfRenderer = instancePDFRenderer();

    const genericMapRenderer = genericMapRendererFactory({
        renderer: pdfRenderer,
    });

    const getPrintOptionValue = (printOptionId) =>
        model.get(`globals.printPDFOptions.${printOptionId}`) || false;

    const setPrintOptionValue = ({ printOptionId, value }) =>
        model.set(`globals.printPDFOptions.${printOptionId}`, value);

    const _getRenderOptions = () => {
        const renderOptions = {};
        Object.keys(PDF_TO_RENDER_OPTIONS_MAP).forEach((renderOption) => {
            renderOptions[renderOption] = getPrintOptionValue(
                PDF_TO_RENDER_OPTIONS_MAP[renderOption],
            );
        });

        return {
            ...DEFAULT_RENDER_OPTIONS,
            ...renderOptions,
        };
    };

    const getPDF = async ({ fileName }) => {
        const node = model.get();
        const imageData = await genericMapRenderer.getThumbnail({
            node,
            viewport: { height: PDF_HEIGHT, width: PDF_WIDTH },
            renderOptions: _getRenderOptions(),
        });
        const { pdf } = imageData;
        const blob = new Blob([pdf.render()], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        const anchorElement = document.createElement('a');

        document.body.appendChild(anchorElement);
        anchorElement.style = 'display: none';
        anchorElement.href = fileURL;
        anchorElement.download = fileName;
        anchorElement.click();
        window.URL.revokeObjectURL(fileURL);
    };

    return {
        getPDF,
        getPrintOptionValue,
        setPrintOptionValue,
    };
};

export default pdfManagerFactory;
